PJQ.views.schedule.EditTaskModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SCHEDULE, 'Modal-Edit-Task'),
        subTemplates: {
            contactBadge: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Contacts-Select-Input-Contacts'),
            comments: new PJQ.templating.Template(PJQ.constants.modules.SCHEDULE, 'Comments'),
            dependencies: new PJQ.templating.Template(PJQ.constants.modules.SCHEDULE, 'Task-Dependencies'),
            requestedChanges: new PJQ.templating.Template(PJQ.constants.modules.SCHEDULE, 'Task-Requested-Changes')
        },
        width: '90%',
        maxWidth: 800,
        statuses: null,
        isShowCloseButton: true,
        onSave: null,
        onClose: null,
        canAddAttachment: true,
        canDeleteAttachment: true,
        canAddComment: true,
        canAddChangeRequest: true,
        canManageChangeRequest: true,
        canEdit: true,
        isAdmin: true,
        isSummaryTask: false,
        start: null,
        finish: null
    },
    events: {
        'click .btn-notification-history': 'viewNotificationHistory',
        'click .btn-close': 'close',
        'click .btn-save': 'save',
        'click .btn-delete': 'delete',
        'click .btn-add-comment': 'addComment',
        'change .progress-slider': 'completionChanged',
        'change .cb-completed-notification': 'disableCompletedNotificationChanged',
        'click .btn-add-dependency': 'addDependency',
        'click .btn-add-successor': 'addSuccessor',
        'click .btn-save-dependency': 'saveDependency',
        'click .btn-cancel-dependency': 'cancelDependency',
        'click .btn-edit-dependency': 'editDependency',
        'click .btn-delete-dependency': 'deleteDependency',
        'click .btn-add-requested-change': 'addRequestedChange',
        'click .btn-delete-requested-change': 'deleteRequestedChange',
        'click .btn-approve-requested-change': 'approveRequestedChangeClicked',
        'click .btn-reject-requested-change': 'rejectRequestedChange',
        'click .btn-view-task': 'viewTask',
        'focusout .input-duration': 'checkDuration'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;

        if (this.options.statuses == null && this.options.schedule != null) {
            this.options.statuses = this.options.schedule.statuses;
        } else {
            this.options.statuses = await PJQ.app.session.fetchScheduleStatuses();
        }

        this.preferences = this.options.project ? this.options.project.preferences : PJQ.app.session.preferences;

        if (this.options.project != null) {
            this.options.canAddComment = this.options.project.hasPermission('schedule.canAddComment');
            this.options.canAddAttachment = this.options.project.hasPermission('schedule.canAddAttachment');
            this.options.canDeleteAttachment = this.options.project.hasPermission('schedule.canDeleteAttachment');
            this.options.canAddChangeRequest = this.options.project.hasPermission('schedule.canAddChangeRequest');
            this.options.canManageChangeRequest = this.options.project.hasPermission('schedule.canManageChangeRequest');
            this.options.canEdit = this.options.project.hasPermission('schedule.isAdmin');
            this.options.isAdmin = this.options.project.hasPermission('schedule.isAdmin');
        } else if (this.model.get('templateId') != null && !(this.model.get('templateId') > 0)) {
            this.options.canAddComment = false;
            this.options.canAddAttachment = false;
            this.options.canDeleteAttachment = false;
            this.options.canAddChangeRequest = false;
            this.options.canManageChangeRequest = false;
            this.options.canEdit = false;
            this.options.isAdmin = false;
        } else if (this.model.get('projectId') > 0) {
            // if there is no project passed in, but this task is for a project
            //  then it is a share and all permissions are false
            this.options.canAddComment = false;
            this.options.canAddAttachment = false;
            this.options.canDeleteAttachment = false;
            this.options.canAddChangeRequest = false;
            this.options.canManageChangeRequest = false;
            this.options.canEdit = false;
            this.options.isAdmin = false;
        } else if (this.options.project == null) {
            this.options.canAddComment = PJQ.app.session.hasPermission('calendar.isAdmin');
            this.options.canAddAttachment = PJQ.app.session.hasPermission('calendar.isAdmin');
            this.options.canDeleteAttachment = PJQ.app.session.hasPermission('calendar.isAdmin');
            this.options.canAddChangeRequest = PJQ.app.session.hasPermission('calendar.isAdmin');
            this.options.canManageChangeRequest = PJQ.app.session.hasPermission('calendar.isAdmin');
            this.options.canEdit = PJQ.app.session.hasPermission('calendar.isAdmin');
            this.options.isAdmin = PJQ.app.session.hasPermission('calendar.isAdmin');
        }

        this.listenTo(this.model, 'change:weekendWork', _.bind(function () {
            let start = this.model.get('start');
            if (start != null && this.model.get('duration') > 0) {
                let start = PJQ.helpers.dateHelpers.getNewDateAddDays(this.model.get('start'), 1, !this.model.get('weekendWork'), true),
                    finish = PJQ.helpers.dateHelpers.getNewDateAddDays(start, this.model.get('duration'), !this.model.get('weekendWork'), true);
                this.model.set('finish', finish);
                this.startPicker.setValue(start);
                this.finishPicker.setValue(finish);
            }
        }, this));

        this.listenTo(this.model, 'change:start', _.bind(function () {
            let start = this.model.get('start'),
                finish = this.model.get('finish'),
                duration = this.model.get('duration'),
                weekendWork = this.model.get('weekendWork');

            if (this.model.get('isMilestone')) {
                this.model.set('finish', start);
            } else {
                if (start != null) {
                    start = PJQ.helpers.dateHelpers.getNewDateAddDays(start, 1, !weekendWork, true);
                    if (finish == null) {
                        finish = PJQ.helpers.dateHelpers.getNewDateAddDays(start, duration === 0 ? 1 : duration, !weekendWork, true);
                        duration = PJQ.helpers.dateHelpers.getDateDaysDiff(finish, start, !weekendWork, true);
                    } else {
                        duration = PJQ.helpers.dateHelpers.getDateDaysDiff(finish, start, !weekendWork, true);
                        if (duration < 1) {
                            duration = 1;
                            finish = start;
                        }
                    }
                } else {
                    // Don't allow unscheduled tasks on tasks that belong to a summary task
                    if (this.model.get('summaryTaskId') != null) {
                        start = finish;
                        duration = 1;
                    }
                    // If task doesn't belong to summary task, then set it as unscheduled
                    else {
                        finish = null;
                        duration = 0;
                    }
                }
                if (this.finishPicker) {
                    this.finishPicker.setValue(finish);
                }
                if (this.startPicker) {
                    this.startPicker.setValue(start);
                }
                this.$('.input-duration').val(duration);
                this.model.set({
                    start: start,
                    finish: finish,
                    duration: duration
                }, {
                    silent: true
                });
            }
        }, this));

        this.listenTo(this.model, 'change:finish', _.bind(function () {
            let start = this.model.get('start'),
                finish = this.model.get('finish'),
                duration = this.model.get('duration'),
                weekendWork = this.model.get('weekendWork');
            if (finish != null) {
                if (start == null) {
                    finish = PJQ.helpers.dateHelpers.getNewDateAddDays(finish, 1, !weekendWork, true);
                    start = finish;
                    duration = 1;
                } else {
                    duration = PJQ.helpers.dateHelpers.getDateDaysDiff(finish, start, !weekendWork, true);
                    finish = PJQ.helpers.dateHelpers.getNewDateAddDays(start, duration, !weekendWork, true);
                    if (duration < 1) {
                        duration = 1;
                        start = finish;
                    }
                }
            } else {
                // Don't allow unscheduled tasks on tasks that belong to a summary task
                if (this.model.get('summaryTaskId') != null) {
                    finish = start;
                    duration = 1;
                }
                // If task doesn't belong to summary task, then set it as unscheduled
                else {
                    start = finish;
                    duration = 0;
                }
            }
            if (this.startPicker) {
                this.startPicker.setValue(start);
            }
            if (this.finishPicker) {
                this.finishPicker.setValue(finish);
            }
            this.$('.input-duration').val(duration);
            this.model.set({
                start: start,
                finish: finish,
                duration: duration
            }, {
                silent: true
            });
        }, this));

        this.listenTo(this.model, 'change:duration', _.bind(function () {
            if (!this.model.get('isMilestone')) {
                let start = this.model.get('start');
                if (start == null) {
                    return;
                }
                let newFinish = start;
                let duration = this.model.get('duration');
                if (duration == null) {
                    this.model.set('duration', null);
                    this.model.set('finish', newFinish, {
                        silent: true
                    });
                } else {
                    // Don't allow unscheduled tasks on tasks that belong to a summary task
                    if (duration === 0 && this.model.get('summaryTaskId')) {
                        this.model.set('duration', null);
                        this.model.set('finish', newFinish, {
                            silent: true
                        });
                        return;
                    }
                    newFinish = PJQ.helpers.dateHelpers.getNewDateAddDays(start, duration, !this.model.get('weekendWork'), true);
                    this.model.set('finish', newFinish, {
                        silent: true,
                        duration: duration
                    });
                }

                this.finishPicker.setValue(newFinish);
            }
        }, this));

        if (this.options.settings == null) {
            if (this.options.project != null) {
                this.settings = await this.options.project.fetchScheduleSettings();
            } else {
                this.settings = await PJQ.app.session.fetchScheduleSettings();
            }
        }

        this.options.isSuccessor = false;
        if ((PJQ.app.session.project && PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.ASAP_SCHEDULE_CONTRAINT_ENABLED)) ||
            (PJQ.app.session.project == null && PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ASAP_SCHEDULE_CONTRAINT_ENABLED))) {
            _.each(this.model.dependencies.models, function (model) {
                if (model.get('taskId') === this.model.get('taskId')) {
                    this.options.isSuccessor = true;
                }
            }, this);
        }

        this.hasCompleteStatus = false;
        _.each(this.options.statuses.models, function (model) {
            if (model.get('name').toLowerCase().includes('complete')) {
                this.hasCompleteStatus = true;
            }
        }, this)

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (this.model.status == null) {
            this.model.status = this.options.statuses.getDefault();
        }
    },
    renderData: function () {
        return {
            model: this.model,
            project: this.options.project,
            settings: this.settings,
            statuses: this.options.statuses,
            schedule: this.options.schedule,
            canAddComment: this.options.canAddComment,
            canAddChangeRequest: this.options.canAddChangeRequest,
            canEdit: this.options.canEdit,
            isAdmin: this.options.isAdmin,
            isSummaryTask: this.options.isSummaryTask,
            isSuccessor: this.options.isSuccessor,
            preferences: this.preferences,
            enableNotificationSettings: this.preferences ? this.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_SCHEDULE_TASK_NOTIFICATION_SETTINGS) : false,
            isOverdue: this.model.get('percentComplete') < 100 && this.model.get('finish') != null && this.model.id != null && PJQ.helpers.dateHelpers.checkDateIsBeforeToday(this.model.get('finish')) && (this.settings && this.settings.get('enableOverdueStatus')) && this.model.status.get('name').toLowerCase() !== 'complete' && this.hasCompleteStatus
        };
    },
    renderDatePickers: function () {
        if (this.options.start) {
            this.model.set('start', this.options.start);
        }
        if (this.options.finish) {
            this.model.set('finish', this.options.finish);
        }

        this.startPicker = new PJQ.inputs.Datepicker({
            el: this.$('.input-start-date'),
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('start')
            },
            onChange: _.bind(function (newDate) {
                this.model.set('start', newDate);
            }, this)
        });

        if (!this.model.get('isMilestone')) {
            this.finishPicker = new PJQ.inputs.Datepicker({
                el: this.$('.input-finish-date'),
                datepickerOptions: {
                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                    defaultDate: this.model.get('finish')
                },
                onChange: _.bind(function (newDate) {
                    this.model.set('finish', newDate);
                }, this)
            });
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        if (this.settings != null && this.settings.isFetched) {
            new PJQ.Binder(this.$el, this.model, {
                watchElements: [
                    'input',
                    'textarea'
                ]
            });

            this.renderDatePickers();

            let groupUserId = null,
                groupLevels = null;
            if (this.options.project != null) {
                groupUserId = this.options.project.get('masterUserId');
                groupLevels = this.options.project.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LEVELS)
            }
            new PJQ.views.groups.GroupsSelectInput({
                el: this.$('.schedule-task-groups'),
                isShowAddButton: false,
                groupLevels: groupLevels,
                groupUserId: groupUserId,
                isReadOnly: !this.options.canEdit,
                addButton: this.$('.btn-edit-groups'),
                selectedGroups: this.model.groups.models,
                onAfterSave: _.bind(function (selectedGroups) {
                    this.model.groups.reset(selectedGroups);
                    this.model.isDirty = true;
                }, this)
            });

            new PJQ.inputs.Selectpicker({
                el: this.$('.select-status'),
                defaultValue: this.model.status.id,
                onChange: _.bind(function (value) {
                    this.model.status = this.options.statuses.get(value);
                    this.model.isDirty = true;
                }, this)
            });

            if (this.options.canEdit) {
                new PJQ.inputs.AutocompleteInput({
                    el: this.$('input.task-category'),
                    source: this.model.collection == null ? [] : _.uniq(_.map(_.filter(this.model.collection.models, _.bind(function (task) {
                        return _.size(task.get('category')) > 0 && task.id !== this.model.id;
                    }, this)), function (task) {
                        return task.get('category');
                    }))
                });
            }

            if (this.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PROJECT_LOCATIONS)) {
                new PJQ.inputs.ProjectLocationPicker({
                    el: this.$('.select-location'),
                    project: this.options.project,
                    canEdit: this.options.canEdit,
                    onChange: _.bind(function (value) {
                        this.model.set('locationId', value);
                    }, this),
                    defaultValue: this.model.get('locationId')
                });
            }

            if (this.options.schedule != null) {
                new PJQ.views.contacts.ContactsSelectInput({
                    el: this.$('.task-assigned'),
                    selectedContact: this.model.assignees.models,
                    isReadOnly: !this.options.canEdit,
                    displayContactsBlock: true,
                    context: this.options.project != null ? PJQ.constants.contacts.contexts.PROJECTCONTACTS : PJQ.constants.contacts.contexts.USERS,
                    isSingleChoice: false,
                    onChange: _.bind(function (selectedContacts) {
                        this.model.assignees.reset(selectedContacts);
                        this.model.isDirty = true;
                    }, this)
                });

                this.renderDependencies();
            }

            this.renderCompletion();

            if (!this.model.isNew()) {
                if (this.options.project != null && this.options.schedule != null) {
                    this.renderRequestedChanges();
                }
                this.renderComments();
            }

            this.fileUploader = new PJQ.views.files.FileUploaderGrid({
                el: this.$('.task-file-uploader'),
                collection: this.model.attachments,
                canUpload: this.options.canAddAttachment,
                canDelete: this.options.canDeleteAttachment,
                previewImageDimension: 150,
                includeProjectAttachments: true,
                onSuccess: _.bind(function () {
                    this.model.isDirty = true;
                }, this),
                onDelete: _.bind(function (attachment, callback) {
                    if (attachment.id > 0) {
                        attachment.set('isDeleted', true);
                    } else {
                        attachment.destroy();
                    }
                    this.model.isDirty = true;
                    callback();
                }, this)
            });
        }

        this.$('.task-name').focus();
        this.$('.input-duration').attr('disabled', this.settings.get('lockSchedule') || !this.options.canEdit || this.model.get('isSummaryTask'));
    },
    checkDuration: function () {
        let duration = this.model.get('duration');
        if (duration == null || duration === 0) {
            duration = 1;
            this.$('.input-duration').val(duration);
            this.model.set('duration', duration);
        }
        // else if (duration === 0) {
        //     this.model.set({
        //         start: null,
        //         finish: null,
        //         duration: 0
        //     }, {silent: true});
        //     this.startPicker.setValue(null);
        //     this.finishPicker.setValue(null);
        //     this.$('.input-duration').attr('disabled', true);
        // }
    },
    viewNotificationHistory: function () {
        this.model.fetchNotifications(function (notifications) {
            new PJQ.views.notifications.NotificationHistory({
                collection: notifications
            });
        })
    },
    addDependency: function () {
        if (this.contextDependency != null) {
            let saved = this.saveDependency();
            if (!saved) {
                return;
            }
        }

        this.contextDependency = new PJQ.models.schedule.TaskDependency({
            taskId: this.model.id,
            dependTaskId: 0,
            offset: 0
        });
        this.renderDependencies();
    },
    addSuccessor: function () {
        if (this.contextDependency != null) {
            let saved = this.saveDependency();
            if (!saved) {
                return;
            }
        }

        this.contextDependency = new PJQ.models.schedule.TaskDependency({
            taskId: 0,
            dependTaskId: this.model.id,
            offset: 0
        });
        this.renderDependencies();
    },
    saveDependency: function () {
        let relTaskId = this.dependencyPicker.getValue();
        if (relTaskId == null) {
            this.dependencyPicker.showError();
            return false;
        }

        if (this.contextDependency.get('taskId') === this.model.id) {
            this.contextDependency.set('dependTaskId', relTaskId);
        } else {
            this.contextDependency.set('taskId', relTaskId);
        }
        let offset = parseInt(this.$('.input-dependency-offset').val());
        this.contextDependency.set({
            type: this.dependencyTypePicker.getValue(),
            offset: !isNaN(offset) ? offset : 0
        });
        this.model.dependencies.add(this.contextDependency);
        this.options.schedule.dependencies.add(this.contextDependency);
        if (!this.contextDependency.get('dependencyId')) {
            this.contextDependency.set('dependencyId', -(this.options.schedule.dependencies.length + 1))
        }
        this.model.isDirty = true;
        this.contextDependency = null;
        this.renderDependencies();

        let minStart = this.model.getMinStart();
        if (this.model.get('start') == null || PJQ.helpers.dateHelpers.getDateDaysDiff(minStart, this.model.get('start'), !this.model.get('weekendWork')) > 0) {
            this.model.set({
                start: minStart,
                finish: PJQ.helpers.dateHelpers.getNewDateAddDays(minStart, this.model.get('duration'), !this.model.get('weekendWork'), true)
            }, {
                silent: true
            });
            this.startPicker.setValue(this.model.get('start'));
            this.finishPicker.setValue(this.model.get('finish'));
        }

        return true;
    },
    editDependency: function (e) {
        let target = $(e.currentTarget),
            cid = target.closest('.card').data('cid');
        this.contextDependency = this.model.dependencies.get(cid);
        this.renderDependencies();
    },
    deleteDependency: function (e) {
        let target = $(e.currentTarget),
            cid = target.closest('.card').data('cid'),
            dependency = this.model.dependencies.get(cid),
            scheduleDependency = this.options.schedule.dependencies.get(dependency.get('dependencyId'));
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this " + (dependency.get('taskId') === this.model.id ? 'dependency' : 'successor') + "?",
            onDelete: _.bind(function () {
                if (dependency.id !== 0) {
                    dependency.set('isDeleted', true);
                    scheduleDependency.set('isDeleted', true);
                } else {
                    this.model.dependencies.remove(dependency);
                    this.options.schedule.dependencies.remove(scheduleDependency);
                }
                this.model.isDirty = true;
                this.renderDependencies();
            }, this)
        });
    },
    cancelDependency: function (e) {
        this.contextDependency = null;
        this.renderDependencies();
    },
    renderDependencies: function () {
        this.renderSubTemplate(false, this.options.subTemplates.dependencies, this.$('.dependencies-outer'), {
            model: this.model,
            schedule: this.options.schedule,
            canEdit: this.options.canEdit,
            contextDependency: this.contextDependency
        }, _.bind(function () {
            this.renderSubTemplate(false, this.options.subTemplates.dependencies, this.$('.successors-outer'), {
                model: this.model,
                schedule: this.options.schedule,
                isSuccessor: true,
                canEdit: this.options.canEdit,
                contextDependency: this.contextDependency
            }, _.bind(function () {
                if (this.contextDependency != null) {
                    this.dependencyPicker = new PJQ.inputs.Selectpicker({
                        el: this.$('.select-dependency'),
                        noneSelectedText: 'Select Task',
                        isIntChoices: true,
                        isLiveSearch: true,
                        isBlockSubtext: true,
                        defaultValue: this.contextDependency.get('taskId') === this.model.id ? this.contextDependency.get('dependTaskId') : this.contextDependency.get('taskId')
                    });

                    this.dependencyTypePicker = new PJQ.inputs.Selectpicker({
                        el: this.$('.select-dependency-type'),
                        noneSelectedText: 'Select Type',
                        defaultValue: this.contextDependency.get('type')
                    });
                }
            }, this));
        }, this));

        let minStart = this.model.getMinStart();
        this.startPicker.setMinDate(minStart);
        if (this.finishPicker != null) {
            this.finishPicker.setMinDate(minStart);
        }
    },
    renderRequestedChanges: function () {
        this.renderSubTemplate(false, this.options.subTemplates.requestedChanges, this.$('.requested-changes-outer'), {
            model: this.model,
            requestedChanges: this.model.requestedChanges,
            canEdit: this.options.canManageChangeRequest
        });
    },
    renderComments: function () {
        this.renderSubTemplate(false, this.options.subTemplates.comments, this.$('.comments-outer'), {
            comments: this.model.comments.models,
            canEdit: this.options.canEdit
        });
    },
    renderCompletion: function () {
        this.progressSlider = this.$('.progress-slider').bootstrapSlider({
            handle: 'square'
        });

        this.$('#progress-slider').append($('<div>', {
            class: 'font-weight-light fs-14 bg-' + this.options.colorClass + ' text-' + (this.options.colorClass === 'warning' ? 'dark' : 'light')
        }).text(this.model.get('percentComplete') + '%'));

        this.completionChanged();
    },
    disableCompletedNotificationChanged: function () {
        let $message = this.$('.comp-notify-message-outer');
        if (this.model.get('disableCompletedNotification')) {
            $message.addClass('hidden');
        } else {
            $message.removeClass('hidden');
        }
    },
    completionChanged: function () {
        let percent = this.progressSlider.data('bootstrapSlider').getValue(),
            $slider = this.$('.slider-selection'),
            $text = this.$('.progress-percent');
        $text.text(percent + '%');
        $text.removeClass('text-danger').removeClass('text-warning').removeClass('text-success');
        $slider.removeClass('slider-bg-danger bg-danger').removeClass('slider-bg-warning bg-warning')
            .removeClass('slider-bg-success bg-success');
        if (percent < 60) {
            $text.addClass('text-danger');
            $slider.addClass('slider-bg-danger bg-danger');
        } else if (percent >= 60 && percent < 100) {
            $text.addClass('text-warning');
            $slider.addClass('slider-bg-warning bg-warning');
        } else {
            $text.addClass('text-success');
            $slider.addClass('slider-bg-success bg-success');
        }
        if (this.model.get('percentComplete') !== percent) {
            this.model.set('percentComplete', percent);
        }
    },
    viewTask: function (e) {
        this.model = this.model.collection.get($(e.currentTarget).data('cid'));
        this.model.fetch({
            success: _.bind(function () {
                this.render();
                this.modal.scrollTop(0);
            }, this)
        })
    },
    addRequestedChange: function () {
        new PJQ.views.schedule.AddRequestedChangeModal({
            task: this.model,
            isSuccessor: this.options.isSuccessor,
            onSave: _.bind(function (requestedChange) {
                this.model.requestedChanges.add(requestedChange);
                if (this.options.schedule != null) {
                    this.options.schedule.pendingRequestedChanges.add(requestedChange);
                }
                this.renderRequestedChanges();
            }, this)
        });
    },
    deleteRequestedChange: function (e) {
        let target = $(e.currentTarget),
            cid = target.closest('.card').data('cid'),
            requestedChange = this.model.requestedChanges.get(cid);
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this requested change?",
            onDelete: _.bind(function () {
                requestedChange.set('isDeleted', true);
                this.model.isDirty = true;
                this.renderRequestedChanges();
            }, this)
        });
    },
    approveRequestedChangeClicked: function (e) {
        let target = $(e.currentTarget),
            cid = target.closest('.card').data('cid'),
            requestedChange = this.model.requestedChanges.get(cid),
            newStart = new Date(requestedChange.get('newStart')),
            newFinish = new Date(requestedChange.get('newFinish'));
        if ((newFinish.getDay() === (0 || 6) || newStart.getDay() === (0 || 6)) && !this.model.get('weekendWork')) {
            new PJQ.views.modals.YesNo({
                header: 'Weekend Work',
                body: 'The new start or finish falls on the weekend and approving will enable weekend work. Continue?',
                onYes: _.bind(function () {
                    this.$('.btn-weekend-work')[0].checked = true;
                    this.model.updateWeekendWork(true);
                    this.approveRequestedChange(requestedChange);
                }, this),
                onNo: _.bind(function () {
                    this.approveRequestedChange(requestedChange);
                }, this)
            })
        } else {
            this.approveRequestedChange(requestedChange);
        }
    },
    approveRequestedChange: function (change) {
        let requestedChange = change;
        requestedChange.approve(_.bind(function (res) {
            let newStart = new Date(res.requestedChange.newStart),
                newFinish = new Date(res.requestedChange.newFinish);
            this.model.set({
                start: newStart,
                finish: newFinish
            });
            this.startPicker.setValue(newStart);
            this.finishPicker.setValue(newFinish);
            this.renderRequestedChanges();
        }, this));
    },
    rejectRequestedChange: function (e) {
        let target = $(e.currentTarget),
            cid = target.closest('.card').data('cid'),
            requestedChange = this.model.requestedChanges.get(cid);
        requestedChange.reject(_.bind(function (res) {
            this.renderRequestedChanges();
        }, this));
    },
    addComment: function () {
        let val = this.$('.item-new-comment').val().trim();
        if (_.size(val) === 0)
            return;

        let comment = new PJQ.models.schedule.TaskComment({
            taskId: this.model.id,
            commentText: val,
            createdOn: new Date()
        });
        if (!this.model.isNew()) {
            comment.save(null, {
                success: _.bind(function () {
                    this.model.comments.add(comment);
                    this.renderComments();
                }, this)
            });
        } else {
            comment.createdBy = PJQ.app.session.user;
            this.model.comments.add(comment);
            this.renderComments();
        }
        this.$('.item-new-comment').val('');
    },
    validate: function () {
        let isValid = true,
            errorText = "";
        // Check if Task Name is filled out
        let nameValid = this.$('.task-name').val().trim().length === 0;
        PJQ.helpers.inputHelpers.setInputError(this.$('.task-name'), !nameValid);
        if (nameValid) {
            errorText += '<li>Task name cannot be empty.</li>';
            isValid = false;
        }

        if (!isValid) {
            if (this.errorAlert != null) {
                this.errorAlert.destroy();
            }
            this.errorAlert = new PJQ.Alert(this.$('.error-container'), {
                type: 'danger',
                text: errorText
            });
        }
        return isValid;
    },
    save: function () {
        if (!this.validate()) {
            return;
        }

        let fnCheck = _.bind(function (noNotifyTaskIds) {
            if (this.fileUploader.isUploading()) {
                new PJQ.views.BaseModal({
                    header: "Files Uploading",
                    body: "You can't save while files are uploading"
                });
            } else {
                this.$('.modal-footer>button').prop('disabled', true);
                new PJQ.Loader(this.$('.btn-save'), {
                    loadingText: ''
                });

                if (this.contextDependency != null) {
                    let saved = this.saveDependency();
                    if (!saved) {
                        return;
                    }
                }
                if (this.model.hasChanged() || this.model.isNew()) {
                    let fnSave = _.bind(function () {
                        this.model.save({
                            preventNotifyTaskIds: noNotifyTaskIds
                        }, {
                            notify: true,
                            success: _.bind(function () {
                                if (typeof this.options.onSave === 'function') {
                                    this.options.onSave(this.model);
                                }
                                this.removeModal();
                            }, this)
                        });
                    }, this);

                    // this code is designed to just match status names that match "complete" exactly" (not case sensitive)
                    // if the task is 100% and the status is not complete (and they have a complete status)
                    // ask if they want to set it to complete
                    // if the task is complete and not set to 100%, ask if they want to set it to 100%
                    let completeStatus = this.options.statuses.find(function (status) {
                        return status.get('name').toLowerCase() === 'complete';
                    });
                    if (completeStatus != null) {
                        let isCompleteStatus = this.model.status.id !== completeStatus.id,
                            header = null,
                            body = null,
                            compSpan = '<strong style="color:' + completeStatus.get('color') + '">Complete</strong>';
                        if (this.model.get('percentComplete') === 100 && isCompleteStatus) {
                            header = 'Mark as Complete?';
                            body = 'This task is marked as 100% complete.  Would you like to change the status to ' + compSpan + '?';
                        } else if (this.model.get('percentComplete') < 100 && !isCompleteStatus) {
                            header = 'Mark as Complete?';
                            body = 'This task is marked as ' + compSpan + '.  Would you like to change the progress to 100%?';
                        }

                        if (header != null && body != null) {
                            new PJQ.views.modals.YesNo({
                                header: header,
                                body: body,
                                onYes: _.bind(function () {
                                    this.model.set('percentComplete', 100);
                                    this.model.status = completeStatus;
                                    fnSave();
                                }, this),
                                onNo: _.bind(function () {
                                    fnSave();
                                }, this)
                            });
                        } else {
                            fnSave();
                        }
                    } else {
                        fnSave();
                    }
                } else {
                    if (typeof this.options.onSave === 'function') {
                        this.options.onSave(this.model);
                    }
                    this.removeModal();
                }
            }
        }, this);
        if (this.model.get('projectId') > 0 && this.settings.get('notificationsEnabled') && this.settings.get('dateChangeNotificationsMode') === 1) {
            let changedTasks = this.model.determineChangedTasks();
            if (_.size(changedTasks) > 0) {
                new PJQ.views.schedule.TaskChangeNotifications({
                    changedTasks: changedTasks,
                    onSave: _.bind(function (res) {
                        fnCheck(res.noNotify);
                    }, this)
                });
            } else {
                fnCheck();
            }
        } else {
            fnCheck();
        }
    },
    close: function () {
        if (this.options.canEdit && this.model.hasChanged()) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.save();
                }, this),
                onDontSave: _.bind(function () {
                    this.model.restore();
                    this.onClose(this.model);
                    this.removeModal();
                }, this)
            });
        } else {
            this.onClose(this.model);
            this.removeModal();
        }
    },
    delete: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this task?",
            onDelete: _.bind(function () {
                if (this.options.onDelete) {
                    this.options.onDelete(this.model);
                }
                this.removeModal();
            }, this)
        });
    }
});

PJQ.views.schedule.AddRequestedChangeModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SCHEDULE, 'Modal-Add-Requested-Change'),
        maxWidth: 500,
        onSave: null
    },
    events: {
        'click .btn-save': 'save'
    },
    beforeModalCreated: function () {
        this.model = new PJQ.models.schedule.RequestedChange({
            taskId: this.options.task.id,
            oldStart: this.options.task.get('start'),
            oldFinish: this.options.task.get('finish'),
            newStart: this.options.task.get('start'),
            newFinish: this.options.task.get('finish')
        });
    },
    renderData: function () {
        return {
            model: this.model,
            isSuccessor: this.options.isSuccessor
        };
    },
    afterRender: function () {
        this.startPicker = new PJQ.inputs.Datepicker({
            el: this.$('.input-new-start'),
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('newStart'),
                minDate: this.options.task.getMinStart()
            },
            onChange: _.bind(function (newDate) {
                this.model.set('newStart', newDate);
            }, this)
        });

        this.finishPicker = new PJQ.inputs.Datepicker({
            el: this.$('.input-new-finish'),
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('newFinish')
            },
            onChange: _.bind(function (newDate) {
                this.model.set('newFinish', newDate);
            }, this)
        });
    },
    save: function () {
        let $reason = this.$('.input-reason'),
            reason = $reason.val();

        let isValid = true;
        if (this.model.get('newStart') == null) {
            this.startPicker.showError();
            isValid = false;
        } else {
            this.startPicker.hideError();
        }

        if (this.model.get('newFinish') == null) {
            this.finishPicker.showError();
            isValid = false;
        } else {
            this.finishPicker.hideError();
        }

        if (_.size(reason) === 0) {
            PJQ.helpers.inputHelpers.setInputError($reason, false);
            isValid = false;
        } else {
            PJQ.helpers.inputHelpers.setInputError($reason, true);
        }

        if (isValid) {
            this.model.save({
                reason: reason
            }, {
                success: _.bind(function () {
                    if (typeof this.options.onSave === 'function') {
                        this.options.onSave(this.model);
                    }

                    this.removeModal();
                    PJQ.notifications.notify.successNotify({
                        message: 'Change request submitted'
                    });
                }, this)
            });
        }
    }
});

PJQ.views.schedule.TaskChangeNotifications = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SCHEDULE, 'Modal-Change-Notifications'),
        maxWidth: 500,
        onSave: null
    },
    events: {
        'change .cb-notify-task': 'changeNotifyTask',
        'change .cb-notify-none': 'changeNotifyNone',
        'click .btn-save': 'save'
    },
    renderData: function () {
        return {
            changedTasks: this.options.changedTasks
        };
    },
    changeNotifyTask: function () {
        this.$('.cb-notify-none').prop('checked', _.size(this.$('.cb-notify-task:checked')) === 0);
    },
    changeNotifyNone: function () {
        if (this.$('.cb-notify-none').prop('checked')) {
            this.$('.cb-notify-task').prop('checked', false);
        }
    },
    save: function () {
        let notify = [],
            noNotify = [];
        this.$('.cb-notify-task').each(function () {
            if ($(this).is(':checked')) {
                notify.push($(this).data('id'));
            } else {
                noNotify.push($(this).data('id'));
            }
        });
        if (typeof this.options.onSave === 'function') {
            this.options.onSave({
                notify: notify,
                noNotify: noNotify
            });
        }
        this.removeModal();
    }
});
